import Vouchers from './Vouchers'

export default [
  { path: '/vouchers', name: 'vouchers', component: Vouchers }
]



// WEBPACK FOOTER //
// ./src/components/vouchers/routes.js